export function shouldTriggerPushNotification(lessonId: number | null, triggerLessonIds: string | null): boolean {
    if (lessonId === null || !triggerLessonIds) return false;

    const ids = String(triggerLessonIds)
        .split(",")
        .map((id) => id.trim())
        .filter((id) => id.length > 0)
        .map((id) => parseInt(id, 10))
        .filter((id) => !isNaN(id));

    return ids.includes(lessonId);
}
